import { ResourceContextProvider } from "ra-core";

import { Task } from "../tasks/Task";
import type { Task as TaskRecord } from "../types";

/**
 * Task rows, with every control upstream gives them.
 *
 * WHY NOT `TasksIterator`, WHICH IS THE COMPONENT THAT ALREADY DOES THIS
 * ---------------------------------------------------------------------
 * It re-applies `!isDone(task) || isRecentlyDone(task)` to whatever it is
 * handed. That is right where it sits -- it renders a to-do list -- and it is
 * fatal to every screen in this directory that deliberately shows closed work:
 * the rows are fetched, selected, handed over and then dropped by the
 * renderer, with nothing on screen to say a filter ate them. Selecting rows
 * and rendering rows are two jobs, and only one of them belongs to a component
 * that also holds a policy.
 *
 * INSIDE A ResourceContextProvider, which is not decoration: `Task` reaches
 * for `useDeleteWithUndoController`, which takes its resource from context.
 * Rendered without one it fails on mount rather than on click, so the symptom
 * is a blank panel rather than a broken menu item.
 *
 * CLOSED ROWS KEEP EVERY CONTROL, deliberately. The checkbox is what re-opens
 * a task, and a task closed by a misclick five minutes and one second ago --
 * just past the grace window, on the wrong side of it -- is precisely the row
 * somebody needs to be able to click.
 */
export const TaskRows = ({
  tasks,
  showContact,
}: {
  tasks: TaskRecord[];
  /** Name the contact on each row. For lists that span more than one. */
  showContact?: boolean;
}) => (
  <ResourceContextProvider value="tasks">
    <div className="space-y-4 md:space-y-2">
      {tasks.map((task) => (
        <Task task={task} showContact={showContact} key={task.id} />
      ))}
    </div>
  </ResourceContextProvider>
);
